import { Grid } from '@material-ui/core';
import React from 'react';
import { Language } from '../../../internationalText';
import Header from './Header';
import Item from './Item';
import LastItem from './LastItem';

export interface ChartProps {
  data: Data;
  progressColor: string;
  backgroundColor: string;
  labelColor: string;
  language: Language;
}

export interface Data {
  projectSearchVolume: number;
  itemAnalysis: GroupAnalysis[];
}

export interface GroupAnalysis {
  searchVolume: number;
  id: number;
  label: string;
  items: ItemAnalysis[];
  moreItemsCount: number;
}

export interface ItemAnalysis {
  searchVolume: number;
  id: number;
  label: string;
}

export const Chart: React.FC<ChartProps> = ({
  data,
  progressColor,
  language,
  backgroundColor,
  labelColor,
}) => {
  return (
    <Grid
      container
      direction="row"
      justifyContent="space-around"
      alignItems="flex-start"
      spacing={4}
    >
      {data.itemAnalysis.map((group) => {
        const share = group.searchVolume / (data.projectSearchVolume ?? 0);
        return (
          <Grid item xs={4} key={group.id}>
            <div className="m-auto pb-6">
              <Grid container direction="column" justifyContent="center" alignItems="center">
                <Header
                  progressColor={progressColor}
                  label={group.label}
                  share={share}
                  backgroundColor={backgroundColor}
                  labelColor={labelColor}
                />
                {group.items.map((item) => (
                  <Item key={item.id} label={item.label} volume={item.searchVolume} />
                ))}
                <LastItem count={group.moreItemsCount} language={language} />
              </Grid>
            </div>
          </Grid>
        );
      })}
      <Grid item xs={12} />
    </Grid>
  );
};

export default Chart;
